export var RoleType;
(function (RoleType) {
    RoleType["Read"] = "READ";
    RoleType["Lock"] = "LOCK";
    RoleType["Unlock"] = "UNLOCK";
    RoleType["ChangeValue"] = "CHANGE_VALUE";
})(RoleType || (RoleType = {}));
//# sourceMappingURL=role-type.js.map